import React, {useState, useEffect} from "react";
import ReactGA from "react-ga";
import ScrollToTop from "../ScrollToTop";
import styled from '@emotion/styled/macro';
import Masthead from "../Masthead";
import CaseTitle from "./CaseTitle";
import mapStrToBr from "../../utility/mapStrToBr";
import convertArrayIntoSingleFragment from "../../utility/convertArrayIntoSingleFragment";
import { Link } from "react-router-dom";
import bg from "../../images/case/caseBg.jpg";
import Temporarily from "./Temporarily";

const Bg = styled.div`
  width: 100%;
  background-image: url(${bg});
  background-size: 360px;
`;

// const CaseKv = styled.div`
//   width: 100%;
//   height: 100vh;
//   background-color: steelblue;
// `;

const CaseSection = styled.section`
  padding: 60px 0px;
  width: 90%;
  max-width: 1200px;
  margin: auto;
  border-left: 0.25px solid rgba(48, 37, 29, 0.1);
  border-right: 0.25px solid rgba(48, 37, 29, 0.1);
  @media screen and (max-width: 767px) {
    padding: 30px 0px;
  }
`;

const CasrLinkBox = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  margin: 60px auto;
  > * {
    flex: 0 0 33.3333%;
  }
  a {
    font-weight: bold;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1rem;
    color: #30251D;
    @media screen and (max-width: 767px) {
      font-size: 14px;
    }
  }
  > div:last-child {
    text-align: right;
  }
  @media screen and (max-width: 767px) {
    margin: 30px auto 60px;
  }
`;

const Line = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: flex-end; */
  &::before {
    content: '';
    width: 40px;
    height: 2px;
    display: block;
    background-color: #30251D;
    margin: auto;
  }
`;

const CaseInfoContainer = styled.div`
  width: 100%;
`;

const CaseInfoImg = styled.div`
  img {
    width: 100%;
  }
`;
const CaseInfoText = styled.div`
  p {
    font-size: 18px;
    text-align: justify;
    letter-spacing: 0.1rem;
    color: #30251D;
    @media screen and (max-width: 1024px) {
      font-size: 16px;
      margin-top: 20px;
    }
  }
`;

const CaseInfoItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  > div {
    width: 50%;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  }
  &:nth-of-type(odd) {
    flex-direction: row-reverse;
    @media screen and (min-width: 767px) {
      ${CaseInfoText} {
        padding-right: 40px;
      }
    }
  }
  &:nth-of-type(even) {
    @media screen and (min-width: 767px) {
      ${CaseInfoText} {
        padding-left: 40px;
      }
    }
  }
  &:not(:last-child) {
    margin-bottom: 100px;
  }
`;

const Note = styled.p`
  font-size: 16px;
  letter-spacing: 0.1rem;
  color: #30251D;
  margin-top: 60px;
  text-align: center;
  @media screen and (max-width: 767px) {
    text-align: left;
  }
`;



const link = ["kestrel", "formosan-masked-civet", "ruddy-kingfisher"];

const Case = (props) => {
  const {title, info, ytId, t} = props.data;
  const [linkIndex] = useState(0);
  const [prev, setPrev] = useState('/kestrel/');
  const [next, setNext] = useState('/formosan-masked-civet/');
  useEffect(()=>{
    const i = window.location.pathname.split('/event/202012_PRADO/')[1].split('/')[0];
    switch (link.indexOf(i)) {
      case 0:
        setPrev('/ruddy-kingfisher/');
        setNext('/formosan-masked-civet/');
        break;
      case 1:
        setPrev('/kestrel/');
        setNext('/ruddy-kingfisher/');
        break;
      case 2:
        setPrev('/formosan-masked-civet/');
        setNext('/kestrel/');
       break;
       default:
        setPrev('/kestrel/');
        setNext('/formosan-masked-civet/');
         break;
    }
    ReactGA.pageview(`/202012_PRADO/${i}`);
    document.title = `TOYOTA Prado - ${i}`;
  }, [])
  return (
    <>
      <ScrollToTop />
      <Bg>
        {ytId ? <Masthead ytId={ytId}/> : <Temporarily img={t}/>}
        
        <CaseSection>
          <CaseTitle title={title}/>
          <CasrLinkBox>
            <div>
              <Link to={prev} onClick={()=>{
                ReactGA.event({
                  category: "202012_PRADO",
                  action: "Click",
                  label: `Case-上一段冒險:${prev}`,
                });
              }}>← 上一段冒險</Link>
            </div>
            <Line />
            <div>
              <Link to={next} onClick={()=>{
                ReactGA.event({
                  category: "202012_PRADO",
                  action: "Click",
                  label: `Case-下一段冒險:${next}`,
                });
              }}>下一段冒險 →</Link>
            </div>
          </CasrLinkBox>
          {/* {props.children} */}
          
          <CaseInfoContainer>
            {info.map((items, keys) => {
              const {text, img} = items;
              return (
                <CaseInfoItem key={keys}>
                  <CaseInfoImg>
                    <img src={img} alt=""/>
                  </CaseInfoImg>
                  <CaseInfoText>
                    <p>{convertArrayIntoSingleFragment(mapStrToBr(text))}</p>
                  </CaseInfoText>
                </CaseInfoItem>
              )
            })}
            {/* <CaseInfoItem>
              <CaseInfoImg>
                <img src="" alt=""/>
              </CaseInfoImg>
              <CaseInfoText>
                <p></p>
              </CaseInfoText>
            </CaseInfoItem> */}


          </CaseInfoContainer>
          <Note>註：為保護野生動物，影片中部分野放點非真實地點，廣告效果請勿模仿</Note>
        </CaseSection>
      </Bg>
    </>
  )
}

export default Case;